import {ApiRole} from '@r/role';
import {getData} from '@r/index';

const controler = 'Images';
const portType = 'fileServer'

interface selfConfigData extends ApiRole {
    data?: {
        _times?: number,
        [propName: string]: any
    },
    header?: {
        [propName: string]: any
    }

}
// 拉去HIS药品并对比接口 /api/Images/geturlbysize
export const geturlbysize = (option: selfConfigData = {}): any => {
    option.url = controler + '/geturlbysize'
    option.type = 'get'
    option.portType = portType
    return getData(option);
}